import React, { useState, useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "./DocumentModal.css";
import CloseIcon from "@mui/icons-material/Close";
import Files from "react-files";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { NotificationManager } from "react-notifications";
import { CircularProgress } from "@mui/material";
import TableScrollDiv from "../../../../../common/component/table/TableScrollDiv";
import { TableCell, TableRow } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { OrderContext } from "../../../../orderList/store";
import { StoreContext } from "../../../../../store/index";
import { StoreContext as OldStoreContext } from "../../../../../../store/Provider";
import { path } from "../../../../../constants/apiPath";
import instance from "../../../../../common/api/interceptor";
import routeConstant from "../../../../../routes/utils/routeConstant";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { DOC_OCR_URL } from "../../../../../../config";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  // minHeight: "20rem",
  height: "30rem",
  bgcolor: "background.paper",

  borderRadius: "1rem",
  boxShadow: 24,
  p: 4,
  padding: "0.3rem 1rem",
};

export default function DocumentModal(props) {
  console.log("DocumentModal", props);

  const column = [
    "Line No.",
    "Item No.",
    "Description",
    "Inner Packs",
    "Inner Package Type",
    "Outer pack",
    "Outer Package Type",
    //
    "Outer Pack Length",
    "Outer Pack Width",
    "Outer Pack Height",
    "Unit Of Dimenssions",
    //
    "Qty. Ordered",
    "Qty. Received",
    "Qty. Remaining",
    "Unit Of Qty.",

    //
    "Actual Volume",
    "Unit of Volume",
    "Actual Weight",
    "Unit of Weight",

    "Item Price",
    "Total Price",
    "Req. in Store Date",
    "INCO term",
    "Additional Terms",
    "Confirm Number",
    "Container Number",
    "Confirm Date",
  ];

  const [document, setDocument] = React.useState([]);
  const [fileError, setFileError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [lineData, setLineData] = useState([]);
  const location = useLocation();
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);
  const navigate = useNavigate();

  const onFilesError = (error, file) => {
    NotificationManager.error(error.message, "", 3000);
    setFileError(`Error code ${error.code} : ${error.message}.`);
  };
  const onFilesChange = (files) => {
    setDocument(files);
    // setLoading(true);

    // document.length !== 0 && setFileError("");
  };

  const onUploadClick = () => {
    if (document.length) {
      const orderLine = JSON.parse(
        JSON.stringify(location.state.editOrderJSON ?? [])
      );

      console.log("filelocation", orderLine.OrderHeader.OrderPK);
      const formData = new FormData();
      formData.append("file", document[0]);
      formData.append("orderpk", orderLine.OrderHeader.OrderPK);
      formData.append("filelocation", "file://");
      setLoading(true);
      axios
        .post(`${DOC_OCR_URL}/api/LineDetails/GetLineDetails`, formData)
        .then((res) => {
          if (res.data.hasOwnProperty("OrderHeader")) {
            setLineData([...res.data.OrderHeader.OrderLinesCollection]);
          }
          console.log(res);
          setLoading(false);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            NotificationManager.error(err?.response?.data?.message, "", 3000);
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setLoading(false);
        });
    } else {
      NotificationManager.error("Please pick document!", "", 3000);
    }
  };

  const updateOrderLine = () => {
    if (location.state) {
      const orderLine = JSON.parse(
        JSON.stringify(location.state.editOrderJSON ?? [])
      );

      if (orderLine.OrderLinesCollection.length) {
        const arr = [...lineData];
        arr.map((item, index) => {
          item.LineIndex = orderLine.OrderLinesCollection.length + index + 1;
        });
        orderLine.OrderLinesCollection = [
          ...orderLine.OrderLinesCollection,
          ...arr,
        ];
      } else {
        const arr = JSON.parse(JSON.stringify(lineData ?? []));
        arr.map((item, index) => {
          item.LineIndex = index + 1;
        });

        orderLine.OrderLinesCollection = [...arr];
      }

      context.setBackDropOpen(true);

      props.handleClose();
      const roles = oldContext.omsUserData.UserRoles;
      instance
        .patch(`${path.EDIT_POST_ORDER}?roles=${roles}`, orderLine)
        .then((res) => {
          context.setBackDropOpen(false);
          if (res.Is_Success) {
            context.setDashBoardBody({
              page: 0,
              dataLength: 0,
              hasMore: true,
              pageSize: 10,
            });
            context.setDashboardData({});
            NotificationManager.success(res.Message, "", 3000);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
          if (location.pathname.includes("dashboard")) {
            navigate(routeConstant.ORDER_DASHBOARD);
          } else if (location.pathname.includes("edit-order")) {
            navigate(-2);
          }
        })
        .catch((err) => {
          context.setBackDropOpen(false);
          setDocument([]);

          console.error(err);
          if (err.response) {
            NotificationManager.error(
              err.response.data.ExceptionMessage,
              "",
              3000
            );
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    }
  };

  return (
    <div className="upload-docs">
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={props.open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="d-flex justify-content-between">
            <h4>Upload document to update Order Line</h4>
            <div className="close-icon">
              <CloseIcon
                onClick={() => {
                  setDocument([]);
                  props.handleClose();
                }}
              />
            </div>
          </div>

          {document.length && lineData.length ? (
            <>
              <>
                <TableScrollDiv className="_orderLineTable" column={column}>
                  {false ? (
                    <TableRow>
                      <TableCell align="left" colSpan={column.length}>
                        No line details added
                      </TableCell>
                    </TableRow>
                  ) : (
                    lineData.map((row, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell className="_orderLineAutoComplete">
                            {row.LinePartNumber}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineDescription}
                          </TableCell>
                          <TableCell className="_orderLineAutoComplete">
                            {row.LineInnerPacks}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineInnerPacksUnit}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineOuterPacks}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineOuterPacksUnit}
                          </TableCell>
                          <TableCell className="_orderLineAutoComplete">
                            {row.LineOuterPacksLength}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineOuterPacksWidth}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineOuterPacksHeight}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.UnitOfDimension}
                          </TableCell>
                          <TableCell className="_orderLineAutoComplete">
                            {row.LineInvoicedQuantity}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineRecievedQuantity}
                          </TableCell>
                          <TableCell className="_orderLineAutoComplete">
                            {row.LineRemainingQuantity}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.UnitOfQuantity}
                          </TableCell>
                          <TableCell className="_orderLineAutoComplete">
                            {row.LineActualVolume}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineUnitOfVolume}
                          </TableCell>
                          <TableCell className="_orderLineNumber">
                            {row.LineActualWeight}
                          </TableCell>
                          <TableCell className="_orderLineDateField">
                            {row.LineUnitOfWeight}
                          </TableCell>
                          {/* incoTerm */}
                          <TableCell className="_orderLineAutoComplete">
                            {row.LineItemPrice}
                          </TableCell>
                          <TableCell>{row.LineTotalPrice}</TableCell>
                          <TableCell>{row.LineReqInStoreDate}</TableCell>
                          <TableCell>{row.LineIncoTerms}</TableCell>
                          <TableCell className="_orderLineDateField">
                            {row.LineAdditionalTerms}
                          </TableCell>
                          <TableCell>{row.LineConfirmNumber}</TableCell>
                          <TableCell>{row.LineContainerNumber}</TableCell>
                          <TableCell>{row.LineConfirmDate}</TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableScrollDiv>

                <div className="button-table">
                  <button className="updateButton " onClick={updateOrderLine}>
                    Update Line
                  </button>
                  <button
                    className="discardButton "
                    onClick={() => {
                      setDocument([]);
                      setLineData([]);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            </>
          ) : (
            <>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <div>Uploading document please wait....</div>
                  <CircularProgress size="1.5rem" />
                </div>
              ) : (
                <>
                  <Files
                    className="files-dropzone"
                    style={{ minHeight: "15rem" }}
                    dragActiveClassName="files-dropzone-active"
                    onChange={onFilesChange}
                    onError={onFilesError}
                    accepts={[".pdf", ".docx", ".xlsx", ".xls", ".csv"]}
                    maxFileSize={2048000}
                    minFileSize={0}
                    // clickable={!inputDisabled}
                    multiple={false}
                    // disabled={inputDisabled}
                  >
                    {document.length ? (
                      <div className="d-flex flex-column justify-content-center align-item-center">
                        <UploadFileIcon
                          style={{ height: "7rem", width: "7rem" }}
                        />
                        <div>{document[0].name}</div>
                      </div>
                    ) : (
                      <>
                        <CloudUploadOutlinedIcon />
                        <p>Drag and Drop Docs Here</p>
                        <span>or</span>
                        <p>Click here to browse Docs</p>
                        <p className="_filemaxInfo">
                          Max. File size should be less than 2MB
                        </p>
                      </>
                    )}
                  </Files>
                  <div className="button-table">
                    <button className="updateButton " onClick={onUploadClick}>
                      Upload
                    </button>
                    <button
                      className="discardButton "
                      onClick={() => {
                        setDocument([]);
                      }}
                    >
                      Discard
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}
